import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowReference } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { ShowIntegerChoices } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type AuthorPublisherViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  publisherValue: { displayId: string; id: string } | null;
  percentageValue?: { displayId: string; id: string } | null;
  percentage: number;
  durationInYearsValue?: { displayId: string; id: string } | null;
  durationInYears: number | undefined;
  autoRenewalYearsValue?: { displayId: string; id: string } | null;
  autoRenewalYears: number | undefined;
};

export const AuthorPublisherViewForm: React.FC<AuthorPublisherViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      publisherValue,
      percentage = 0,
      durationInYears = undefined,
      autoRenewalYears = undefined,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupAuthorPublisherLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowReference
                  label={langStore.AuthorPublisherPublisherLabel}
                  selectedValue={langStore.displayIdByLang(
                    publisherValue?.displayId
                  )}
                />
                <ShowNumber
                  value={percentage}
                  label={langStore.AuthorPublisherPercentageLabel}
                  decimalScale={2}
                />
                <ShowIntegerChoices
                  value={durationInYears}
                  label={langStore.AuthorPublisherDurationInYearsLabel}
                  unitSingular={"año"}
                  unitPlural={"años"}
                  nullText={langStore.AuthorPublisherDurationInYearsNullText}
                />
                <ShowIntegerChoices
                  value={autoRenewalYears}
                  label={langStore.AuthorPublisherAutoRenewalYearsLabel}
                  unitSingular={"año"}
                  unitPlural={"años"}
                  nullText={langStore.AuthorPublisherAutoRenewalYearsNullText}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
